__turbopack_context__.v({
  "audience": "course-description-module-scss-module___l52bq__audience",
  "audience-list": "course-description-module-scss-module___l52bq__audience-list",
  "audience-title": "course-description-module-scss-module___l52bq__audience-title",
  "description-header": "course-description-module-scss-module___l52bq__description-header",
});
